<app-collapsible-section
title="Text Messaging"
[isExpanded]="isExpanded"
[isCompleted]="isCompleted"
[showDoneButton]="true"
(toggle)="onTextMessageToggle($event)"
(done)="onTextMessageDone()">
<ng-template #sectionContent>
  <div class="text-message-content">

    <!-- Preview Section -->
    <div class="preview-section">

      <!-- Empty state: no SMS or MMS data yet -->
      <div *ngIf="!hasSmsData && !hasMmsData" class="create-email-input" (click)="onCreateTextMessage()">
        <div class="input-content">
          <span class="input-text">Create Text Messaging Campaign</span>
        </div>
        <div class="plus-icon">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 1V13M1 7H13" stroke="#0030A8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>

      <!-- Header shown when SMS or MMS data exists -->
      <div *ngIf="hasSmsData || hasMmsData" class="preview-header">
        <div class="preview-title-section">
          <h4 class="preview-title">Your Message Preview </h4>
        </div>
        <div class="preview-actions">
          <button class="action-btn edit-btn" (click)="onCreateTextMessage()">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3.66797 3.66674H3.0013C2.64768 3.66674 2.30854 3.80721 2.05849 4.05726C1.80844 4.30731 1.66797 4.64645 1.66797 5.00007V11.0001C1.66797 11.3537 1.80844 11.6928 2.05849 11.9429C2.30854 12.1929 2.64768 12.3334 3.0013 12.3334H9.0013C9.35492 12.3334 9.69406 12.1929 9.94411 11.9429C10.1942 11.6928 10.3346 11.3537 10.3346 11.0001V10.3334M9.66797 2.3334L11.668 4.3334M12.5913 3.39007C12.8539 3.12751 13.0014 2.77139 13.0014 2.40007C13.0014 2.02875 12.8539 1.67264 12.5913 1.41007C12.3287 1.14751 11.9726 1 11.6013 1C11.23 1 10.8739 1.14751 10.6113 1.41007L5.0013 7.00007V9.00007H7.0013L12.5913 3.39007Z" stroke="#15172E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <button class="action-btn delete-btn" (click)="onDeleteMessage()">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.66797 4.66667H13.3346M6.66797 7.33333V11.3333M9.33464 7.33333V11.3333M3.33464 4.66667L4.0013 12.6667C4.0013 13.0203 4.14178 13.3594 4.39183 13.6095C4.64187 13.8595 4.98101 14 5.33464 14H10.668C11.0216 14 11.3607 13.8595 11.6108 13.6095C11.8608 13.3594 12.0013 13.0203 12.0013 12.6667L12.668 4.66667M6.0013 4.66667V2.66667C6.0013 2.48986 6.07154 2.32029 6.19656 2.19526C6.32159 2.07024 6.49116 2 6.66797 2H9.33464C9.51145 2 9.68102 2.07024 9.80604 2.19526C9.93106 2.32029 10.0013 2.48986 10.0013 2.66667V4.66667" stroke="#AF1820" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      </div>

      <!-- SMS preview bubble -->
      <div *ngIf="hasSmsData" class="message-bubble-container">

        <!-- Single segment -->
        <ng-container *ngIf="smsSegmentParts.length <= 1">
          <div class="message-bubble">
            <div class="message-content">
              <p class="message-text">
                {{ textMessageData.textMessage || 'Your message will appear here' }}
                <span *ngIf="textMessageData.linkText"><br><br>{{ textMessageData.linkText }}</span>
              </p>
            </div>
          </div>
        </ng-container>

        <!-- Multi-segment: one bubble per segment -->
        <ng-container *ngIf="smsSegmentParts.length > 1">
          <div class="segment-group"
               *ngFor="let part of smsSegmentParts; let i = index; trackBy: trackByIndex">
            <div class="message-bubble">
              <div class="message-content">
                <p class="message-text">{{ part }}</p>
              </div>
            </div>
          </div>
        </ng-container>

      </div>

      <!-- MMS preview bubble -->
      <div *ngIf="hasMmsData" class="message-bubble-container">

        <!-- Bubble 1: single caption segment -->
        <ng-container *ngIf="mmsCaptionSegmentParts.length <= 1">
          <div class="message-bubble mms-preview-bubble">
            <div class="message-content">
              <div class="mms-preview-image-box" *ngIf="textMessageData.mmsImageUrl">
                <img [src]="textMessageData.mmsImageUrl" class="mms-preview-thumb" alt="MMS image">
              </div>
              <p class="message-text mms-caption-text" *ngIf="textMessageData.mmsCaption">{{ textMessageData.mmsCaption }}</p>
              <p class="mms-preview-url" *ngIf="textMessageData.mmsUrl">{{ textMessageData.mmsUrl }}</p>
            </div>
          </div>
        </ng-container>

        <!-- Bubble 1: multi-segment caption -->
        <ng-container *ngIf="mmsCaptionSegmentParts.length > 1">
          <div class="segment-group"
               *ngFor="let part of mmsCaptionSegmentParts; let i = index; trackBy: trackByIndex">
            <div class="message-bubble mms-preview-bubble">
              <div class="message-content">
                <div class="mms-preview-image-box" *ngIf="i === 0 && textMessageData.mmsImageUrl">
                  <img [src]="textMessageData.mmsImageUrl" class="mms-preview-thumb" alt="MMS image">
                </div>
                <p class="message-text mms-caption-text">{{ part }}</p>
                <p class="mms-preview-url" *ngIf="i === 0 && textMessageData.mmsUrl">{{ textMessageData.mmsUrl }}</p>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Bubble 2: single segment -->
        <ng-container *ngIf="textMessageData.splitTwoBubbles && textMessageData.mmsBubble2Text">
          <ng-container *ngIf="mmsBubble2SegmentParts.length <= 1">
            <div class="message-bubble mms-preview-bubble">
              <div class="message-content">
                <p class="message-text">{{ textMessageData.mmsBubble2Text }}</p>
              </div>
            </div>
          </ng-container>

          <!-- Bubble 2: multi-segment -->
          <ng-container *ngIf="mmsBubble2SegmentParts.length > 1">
            <div class="segment-group"
                 *ngFor="let part of mmsBubble2SegmentParts; let i = index; trackBy: trackByIndex">
              <div class="message-bubble mms-preview-bubble">
                <div class="message-content">
                  <p class="message-text">{{ part }}</p>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>

      </div>

    </div>

    <!-- Done Button -->
    <div class="done-button-container">
      <button class="btn btn-primary btn-medium" (click)="onTextMessageDone()">
        {{ (hasSmsData || hasMmsData) ? 'Done' : 'Create' }}
      </button>
    </div>
  </div>
</ng-template>
</app-collapsible-section>

<!-- Text Message Modal -->
<app-create-text-modal
  [isOpen]="isModalOpen"
  [initialData]="textMessageData"
  (close)="onCloseModal()"
  (save)="onSaveTextMessage($event)">
</app-create-text-modal>
